import * as React from 'react';
import type { PowerType } from '../../../../app/ApiGen';
import type { InputComponentProps } from '../../../../design-system';
import { type MenuOption, SelectionMenu } from '../../../SelectionMenu';

const options: MenuOption<PowerType>[] = [
  { label: 'AC, single phase', value: 'AC_1_PHASE' },
  { label: 'AC, 3-phase', value: 'AC_3_PHASE' },
  { label: 'DC', value: 'DC' },
];

export const PowerTypeInput: React.FC<InputComponentProps<PowerType>> = ({
  disabled,
  error,
  helperText,
  onBlur,
  onChange,
  name,
  value,
}) => (
  <SelectionMenu
    aria-label="Power type"
    disabled={disabled}
    error={error}
    helperText={helperText}
    name={name}
    onBlur={onBlur}
    onChange={onChange}
    options={options}
    value={value}
  />
);
